package search.global

import search.searchFilterStores.ActiveSearchOptionsStore

class ActiveGlobalSearchOptionsStore : ActiveSearchOptionsStore()
